/**
 * GlassTabBarBackground - Y2K Glassmorphism Tab Bar Background
 *
 * Frosted glass background for the entire bottom tab bar container.
 * Provides unified Y2K aesthetic foundation for GlassTabIcon components.
 *
 * Features:
 * - 2-layer stack: solid dark base → BlurView
 * - Full-width frosted glass effect (intensity: 60)
 * - Dark tint for Y2K midnight aesthetic
 * - Minimal layers for performance (2 of 50 budget)
 *
 * Performance:
 * - 2 elements per tab bar (single instance)
 * - GPU-accelerated blur (expo-blur)
 * - No animations (static background)
 *
 * @example
 * // In (tabs)/_layout.tsx
 * <Tabs
 *   screenOptions={{
 *     tabBarBackground: () => <GlassTabBarBackground />,
 *   }}
 * />
 */

import React from 'react';
import { View, StyleSheet } from 'react-native';
import { BlurView } from 'expo-blur';

export const GlassTabBarBackground: React.FC = () => {
  return (
    <View style={styles.container}>
      {/* Layer 1: Solid dark base (#111827 gray-900) */}
      <View style={[StyleSheet.absoluteFill, styles.baseLayer]} />

      {/* Layer 2: BlurView for frosted glass effect */}
      <BlurView intensity={60} tint="dark" style={StyleSheet.absoluteFill} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFill,
  },
  baseLayer: {
    backgroundColor: '#111827', // Matches ScoreCard solid base
  },
});
